import { Injectable } from "@angular/core";
import { StructuredProcessData, StructuredProcessInstance, StructuredProcessInstanceStatusEnum, UserCompetenciesData } from "./strcutredProcess-data";
import { Observable } from "rxjs";
import { StructuredProcessArtifact, StructuredProcessArtifactType } from "./structuredProcess-artifactData";


@Injectable({
    providedIn: 'root'
  })
  export abstract class AbstractStructuredProcessService {
    abstract getStructuredProcess(processId?: string): Observable<StructuredProcessData>;
    abstract getStructuredProcessInstance(): Observable<StructuredProcessInstance>;
    abstract startProcess(): Observable<StructuredProcessInstance>;
    abstract setStructuredProcessCurrentStep(stepId: string): Observable<StructuredProcessInstance>;
    abstract setStructuredProcessStepStateFromUser(stepId: string, state: StructuredProcessInstanceStatusEnum): Observable<StructuredProcessInstance>;
    abstract getStructuredProcessArtifact(artifactType: StructuredProcessArtifactType): Observable<StructuredProcessArtifact | null>;
    abstract saveStructuredProcessArtifact(structuredProcessArtifact: StructuredProcessArtifact): Observable<StructuredProcessArtifact>;
    abstract resetStructuredProcessArtifact(artifactType: StructuredProcessArtifactType): Observable<StructuredProcessInstance>;
    abstract exportStructuredProcessWorkplan(processId: string): Observable<ArrayBuffer>;
  }